const DB = {
  terms: {
    code: "Success",
    data: {
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?uis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
      status: "Success",
      version: "1.1",
    },
    message: "Success",
    status: "success",
  },

  acceptTerms: {
    status: "success",
    data: {
      status: "success",
    },
  },

  auth: {
    access_token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ1c2VyX2FjY291bnRfaWQiLCJ0ZXJtc0FncmVlbWVudCI6ImFncmVlZCIsIm5hbWVfdGgiOiJuYW1lIHRoIiwibmFtZV9lbiI6Im5hbWUgZW4iLCJtb2JpbGUiOiIwODU1NTU1NTU1In0.6oejQNDWwTIp32R83XFyvOQwNUZzkyvBw2VL5paEwV8",

    token_type: "Bearer",
    expires_in: "3600",
    refresh_token: "mock_refresh_token_from_key",
    scope: "oob",
    id_token: "string",
    id_token_type: "string",
  },

  authafterAccept: {
    access_token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ1c2VyX2FjY291bnRfaWQifQ.GTjC50B46Q5K1hDWHaG-EWJk_PljdgxMhPbSgp0-EcU",
    token_type: "Bearer",
    expires_in: "3600",
    refresh_token: "mock_refresh_token_from_key",
    scope: "oob",
    id_token: "string",
    id_token_type: "string",
  },

  dealsEmtpy: {
    totalPages: 3,
    entries: [],
  },

  deals: {
    totalPages: 3,
    entries: [
      {
        _links: {
          self: "string",
        },
        id: 1,
        title: "Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "For a limited time only, get 50 THB off any purchase at 7-11 during this holiday. Merry Xmas and Happy New year!",
        thumbnail:
          "https://vms-light-sto-dev.abc.abc-dev.network/X1UBhybX1jhXnPgeux8q5gVR.png",
        bgPicture:
          "https://vms-light-sto-dev.abc.abc-dev.network/X1UBhybX1jhXnPgeux8q5gVR.png",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 4,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1485893226355-9a1c32a0c81e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 2,
        title: "Everyhing must go!",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description: "Get everything at 50% off",
        thumbnail:
          "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645517976245-569a91016f79?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=661&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1535953472862-9cc610a70f8a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 3,
        title: "Discount Discount Discount",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description: "First, we eat. Then, we do everything else.",
        thumbnail:
          "https://images.unsplash.com/photo-1585238342024-78d387f4a707?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1644704480315-bc18243f5f79?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 454,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1484186139897-d5fc6b908812?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 4,
        title: "For one day only",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "To live a full life, you have to fill your stomach first.",
        thumbnail:
          "https://images.unsplash.com/photo-1550950158-d0d960dff51b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645442083959-adf016a9641a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 95,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1485206412256-701ccc5b93ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1188&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 5,
        title: "Sale Sale Sale",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "Dear diet, things just aren’t looking good for the both of us. It’s not me, it’s you. You’re too much work. You’re boring and I can’t stop cheating on you.",
        thumbnail:
          "https://images.unsplash.com/photo-1505394033641-40c6ad1178d7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645466525466-647ef246067f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 57,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1529068755536-a5ade0dcb4e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1162&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 6,
        title: "Shoppee",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "It’s essential for every party to have cake. If there’s no cake, then it’s only a meeting.",
        thumbnail:
          "https://images.unsplash.com/photo-1560684352-8497838a2229?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1056&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645268087365-953f5638f21e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 76,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 7,
        title: "Buy 1 Get 1 Free",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "9 out of 10 people love chocolate. And the 10th person is always lying.",
        thumbnail:
          "https://images.unsplash.com/photo-1459789034005-ba29c5783491?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1238&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1630336724607-ec019b0fc4ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 32,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1598641795816-a84ac9eac40c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1162&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 8,
        title: "Buy 2 Get 1 Free",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "Eat, drink and live free. There’s no telling what might happen tomorrow.",
        thumbnail:
          "https://images.unsplash.com/photo-1556690171-9f6645f4455e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645377370247-c4354ce4d328?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 12,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1562783530-df27356a200d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 9,
        title: "Discount on selected items",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "Dine well and you’ll be able to think well, sleep well, and live well.",
        thumbnail:
          "https://images.unsplash.com/photo-1605851868183-7a4de52117fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1645114422321-fd2103bfaa0b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 42,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1543123820-ac4a5f77da38?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1072&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 10,
        title: "Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any 7-11 store",
        description:
          "It’s not true that money can’t buy happiness. I mean, have you tried buying ice cream? It’s the same thing!",
        thumbnail:
          "https://images.unsplash.com/photo-1484980859177-5ac1249fda6f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1229&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1644751291719-574ef771ba30?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 23,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "1",
          name: "True Move H",
          logo: "https://images.unsplash.com/photo-1634316887949-a417f029f843?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
        },
      },
    ],
  },

  deals2: {
    totalPages: 3,
    entries: [
      {
        _links: {
          self: "string",
        },
        id: 11,
        title: "H&M Holiday Sale",
        tagline: "Get 50% off for any purchase at any H&M outlet",
        description:
          "For a limited time only, get 50% off for any purchase at H&M during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZnJpZW5kc3xlbnwwfDB8MHx8&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 4,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1615439244365-b9b37c99f29c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8d29tZW4lMjBwb3J0cmFpdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 12,
        title: "Uniqlo Anniversary Promo",
        tagline: "Get 200 THB off for any purchase of summer collection",
        description:
          "For a limited time only, get 200 TBH off for any purchase at Uniqlo during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1584030763242-548b898376a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjd8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1591035897819-f4bdf739f446?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8ZnJpZW5kc3xlbnwwfDB8MHx8&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 13,
        title: "Tokyo Bubble Tea Milktea Day Promo",
        tagline: "Buy 1 get 1 Bubble Tea for any purchase",
        description:
          "For a limited time only, get 1 milktea for free for any purchase at Tokyo Bubble Tea during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1598641795816-a84ac9eac40c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1589156191108-c762ff4b96ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 14,
        title: "Jollibee Happy Holiday Discount",
        tagline: "Get 250 THB off for any purchase at any Jollibee store",
        description:
          "For a limited time only, get 250 TBH off for any purchase at Jollibee during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1563200337-ac0b81474233?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDl8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1511988617509-a57c8a288659?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjN8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjN8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 15,
        title: "Chowking Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Chowking store",
        thumbnail:
          "https://images.unsplash.com/photo-1548964095-b9a292144866?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzd8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1603648279492-a526670a508d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjh8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 16,
        title: "Potato Corner Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Potato Corner store",
        description:
          "For a limited time only, get 50 TBH off for any purchase at Potato Corner during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1626489479086-187aa61461fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTl8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1569617084133-26942bb441f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjh8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1564640130169-e9672b4e9506?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzJ8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 17,
        title: "Wolfgang Steak Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Wolfgang Steak store",
        description:
          "For a limited time only, get 50 TBH off for any purchase at Wolfgang Steak during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1642060603505-e716140d45d2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTh8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1613109040830-ffdd96756f5e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzJ8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1571234018566-1d3cc5d2991a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzF8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 18,
        title: "Purple Oven Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Purple Oven store",
        description:
          "For a limited time only, get 50 TBH off for any purchase at Purple Oven during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1642599222043-c60ccf781b9b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nzd8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1582578598774-a377d4b32223?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTB8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1609694923332-ac96287d7203?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTZ8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 19,
        title: "Contis Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Contis store",
        description:
          "For a limited time only, get 50 TBH off for any purchase at Contis during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1625241189662-2980453ebffc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTd8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1591089079607-73a2d0343394?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 20,
        title: "Bonchon Happy Holiday Discount",
        tagline: "Get 50 THB off for any purchase at any Bonchon store",
        description:
          "For a limited time only, get 50 TBH off for any purchase at Bonchon during this holiday.",
        thumbnail:
          "https://images.unsplash.com/photo-1593508512255-86ab42a8e620?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NjR8fG1hbnxlbnwwfDJ8MHx8&auto=format&fit=crop&w=600&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1622037022824-0c71d511ef3c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDF8fGZyaWVuZHN8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 123,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "2",
          name: "H&M",
          logo: "https://images.unsplash.com/photo-1560087637-bf1e338a40a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTB8fHdvbWVuJTIwcG9ydHJhaXR8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60",
        },
      },
    ],
  },

  deals3: {
    totalPages: 3,
    entries: [
      {
        _links: {
          self: "string",
        },
        id: 21,
        title: "Raspberry Season Discount",
        tagline: "Buy 1 kilo and get 40% discount",
        description: "Buy 1 kilo and get 40% discount on your purchase.",
        thumbnail:
          "https://images.unsplash.com/photo-1618422689173-3dbcdeb82fa7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzF8fGZvb2R8ZW58MHwyfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1624813743954-d32f24df6cf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1541598060305-1a7438a7f937?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 22,
        title: "Tech loyalty discount",
        tagline:
          "Join our loyalty program for exclusive offers and updates on the latest and greatest inventory as it comes in!!",
        description:
          "Join our loyalty program for exclusive offers and updates on the latest and greatest inventory as it comes in!",
        thumbnail:
          "https://images.unsplash.com/photo-1618422689173-3dbcdeb82fa7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzF8fGZvb2R8ZW58MHwyfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
        bgPicture:
          "https://images.unsplash.com/photo-1624813743954-d32f24df6cf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1593259037198-c720f4420d7f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 23,
        title: "Summer promo",
        tagline:
          "It’s getting hot out there! Get ready for that upcoming beach vacay by shopping our summer collection for the hottest deals we’ve ever offered!",
        description:
          "It’s getting hot out there! Get ready for that upcoming beach vacay by shopping our summer collection for the hottest deals we’ve ever offered",
        thumbnail:
          "https://images.unsplash.com/photo-1551982398-b71c6a69ff42?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=845&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1541417904950-b855846fe074?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1141&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1443181844940-9042ec79924b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 24,
        title: "Free Samples",
        tagline:
          "Try before you buy! This weekend only, get the chance to sample some of your favorite perfume before you pull the trigger on them. See you this weekend!",
        description:
          "Try before you buy! This weekend only, get the chance to sample some of your favorite perfume before you pull the trigger on them. See you this weekend!",
        thumbnail:
          "https://images.unsplash.com/photo-1597861533232-cd38ad692071?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=850&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1615634260167-c8cdede054de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1582623081787-05843bd8947a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=888&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 25,
        title: "Back in Stock!!!",
        tagline:
          "Our best-selling Mademoiselle bag have been sold out for months—but they’re back! Grab yours before they’re gone!",
        description:
          "Our most popular Mademoiselle bag are back in stock. But this is the last restock until the next season! Get it now before we sell out!",
        thumbnail:
          "https://images.unsplash.com/photo-1591348278999-ee1d0c06ed7b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1575671153502-a417e2ddd259?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1630396591290-fa3c97cdae27?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 26,
        title: "Flash sale!!!",
        tagline:
          "Next 3 hours only! Shop our limited selection of last season’s styles!",
        description:
          "Next 3 hours only! Shop our limited selection of last season’s styles!",
        thumbnail:
          "https://images.unsplash.com/photo-1545896380-e52bedcce28f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=829&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1548950939-629ecb4d7101?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1643106723544-99bcce3e6792?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 27,
        title: "Flash sale!!!",
        tagline:
          "For a limited time, all our Valentines Day items are 20% cheaper! Surprise your loved ones with a special gift!",
        description:
          "For a limited time, all our Valentines Day items are 20% cheaper! Surprise your loved ones with a special gift!",
        thumbnail:
          "https://images.unsplash.com/photo-1612172914649-26000db6568e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1625108954674-4f2d1ea0a37a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1548544099-a89e27f73a84?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 28,
        title: "LIMITED EDITION!!!",
        tagline:
          "The wait is finally over - the NEW LIMITED EDITION sneakers have arrived. Hurry up and shop before they sell out!",
        description:
          "The wait is finally over - the NEW LIMITED EDITION sneakers have arrived. Hurry up and shop before they sell out!",
        thumbnail:
          "https://images.unsplash.com/photo-1529810313688-44ea1c2d81d3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=941&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1516478177764-9fe5bd7e9717?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the vouchers T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2680&q=80",
        },
      },
      {
        _links: {
          self: "string",
        },
        id: 29,
        title: "LIMITED EDITION!!!",
        tagline:
          "The wait is finally over - the NEW LIMITED EDITION sneakers have arrived. Hurry up and shop before they sell out!",
        description:
          "The wait is finally over - the NEW LIMITED EDITION sneakers have arrived. Hurry up and shop before they sell out!",
        thumbnail:
          "https://images.unsplash.com/photo-1529810313688-44ea1c2d81d3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=941&q=80",
        bgPicture:
          "https://images.unsplash.com/photo-1516478177764-9fe5bd7e9717?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        tnc: "Valid for redemption from 1 Jan 2022 to 31 Jan 2022\nValid on Mon - Fri (Weekdays) at 11:00AM to 1:00PM. Not valid on Public Holidays\nValid at all True Coffee Bangkok Outlets\nValid for redemption on coffee purchases only\nNot valid with other offers / promotions\nTrue reserves the right, at its reasonable discretion, to change the voucher’s T&Cs",
        price: 3,
        startDateTime: "2022-02-18T10:58:08.305Z",
        endDateTime: "2022-02-18T10:58:08.306Z",
        merchant: {
          id: "3",
          name: "Samsung",
          logo: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2680&q=80",
        },
      },
    ],
  },

  merchants: {
    totalPages: 3,
    entries: [
      {
        id: "1",
        name: "True Move H",
        logo: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "2",
        name: "H&M",
        logo: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "3",
        name: "Samsung",
        logo: "https://images.unsplash.com/photo-1485206412256-701ccc5b93ca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1188&q=80",
      },
      {
        id: "4",
        name: "Sony",
        logo: "https://images.unsplash.com/photo-1520183802803-06f731a2059f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "5",
        name: "Microsoft",
        logo: "https://images.unsplash.com/photo-1485206283729-2ca7d035185e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "6",
        name: "Facebook",
        logo: "https://images.unsplash.com/photo-1551179939-b839002d0a18?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "7",
        name: "Xperia",
        logo: "https://images.unsplash.com/photo-1541911087797-f89237bd95d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "8",
        name: "Panasonic",
        logo: "https://images.unsplash.com/photo-1529068755536-a5ade0dcb4e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1162&q=80",
      },
      {
        id: "9",
        name: "Canon",
        logo: "https://images.unsplash.com/photo-1597004897768-c503466472cc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "10",
        name: "Asus",
        logo: "https://images.unsplash.com/photo-1541534401786-2077eed87a74?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
    ],
  },
  merchants2: {
    totalPages: 3,
    entries: [
      {
        id: "11",
        name: "Antii",
        logo: "https://images.unsplash.com/photo-1542892650-7659c76be2e3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1118&q=80",
      },
      {
        id: "12",
        name: "Ashuu",
        logo: "https://images.unsplash.com/photo-1519396970718-780f9a34e2bd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1104&q=80",
      },
      {
        id: "13",
        name: "Alessio",
        logo: "https://images.unsplash.com/photo-1490119551293-c52fcfd96381?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "14",
        name: "Chris",
        logo: "https://images.unsplash.com/photo-1529903543134-d2d0b6858e21?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "15",
        name: "Nohassi",
        logo: "https://images.unsplash.com/photo-1519084278803-b94f11e1c63b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1224&q=80",
      },
      {
        id: "16",
        name: "Joanna",
        logo: "https://images.unsplash.com/photo-1517171771326-cbc7f641008a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1162&q=80",
      },
      {
        id: "17",
        name: "Nikola",
        logo: "https://images.unsplash.com/photo-1429114753120-0733a750d6c1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1128&q=80",
      },
      {
        id: "18",
        name: "Levi",
        logo: "https://images.unsplash.com/photo-1518415692216-ce36b914890f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "19",
        name: "Ahmed",
        logo: "https://images.unsplash.com/photo-1503212556734-c0ca0c49c8b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80",
      },
      {
        id: "20",
        name: "Eric",
        logo: "https://images.unsplash.com/photo-1520302723644-46526f5a7c2a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1072&q=80",
      },
    ],
  },
  merchants3: {
    totalPages: 3,
    entries: [
      {
        id: "100",
        name: "True Move H",
        logo: "https://images.unsplash.com/photo-1645114422321-fd2103bfaa0b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      },
      {
        id: "102",
        name: "Merchant",
        logo: "",
      },
      {
        id: "103",
        name: "Merchant",
        logo: "",
      },
      {
        id: "104",
        name: "Merchant",
        logo: "",
      },
      {
        id: "105",
        name: "Merchant",
        logo: "",
      },
      {
        id: "106",
        name: "Merchant",
        logo: "",
      },
      {
        id: "107",
        name: "True Move H",
        logo: "",
      },
      {
        id: "108",
        name: "Merchant",
        logo: "",
      },
      {
        id: "109",
        name: "Merchant",
        logo: "",
      },
      {
        id: "200",
        name: "Merchant",
        logo: "",
      },
      {
        id: "201",
        name: "True Move H",
        logo: "https://images.unsplash.com/photo-1645114422321-fd2103bfaa0b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      },
      {
        id: "202",
        name: "Merchant",
        logo: "",
      },
      {
        id: "203",
        name: "Merchant",
        logo: "",
      },
      {
        id: "204",
        name: "Merchant",
        logo: "",
      },
      {
        id: "205",
        name: "Merchant",
        logo: "",
      },
      {
        id: "206",
        name: "Merchant",
        logo: "",
      },
      {
        id: "207",
        name: "True Move H",
        logo: "",
      },
      {
        id: "208",
        name: "Merchant",
        logo: "",
      },
      {
        id: "209",
        name: "Merchant",
        logo: "",
      },
      {
        id: "210",
        name: "Merchant",
        logo: "",
      },
    ],
  },
  coins: {
    balance: "123456.123456789",
    account: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
  },

  transactionHistory: {
    transactions: [
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F31",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F32",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F33",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F34",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F35",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F36",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F37",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
      {
        hash: "0x2361920FAAAAAAAAA34CDe81F38",
        type: "Send",
        currency: "ABC",
        amount: "18.12345678",
        timestamp: "2022-03-03T17:10:08.305Z",
        from: "0xc0eb9717ed6e8ebcec77fa28e3da5e531fadeff9",
        to: "0xecb4c0e0d7decbd388bc4fbed7f5bb6d995eafd6",
        logo: "",
      },
    ],
  },

  vouchers1: {
    totalPages: 1,
    entries: [
      {
        id: "1",
        thumbnail:
          "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        title: "Weekday Lunchtime Special January",
        merchant: {
          logo: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
          name: "True Coffee",
        },
        company: "True Coffee",
        barCode: "abcdef",
        text: "abc wallet",
        qrCode: "aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2",
        promo: "True Coffee Weekday Lunchtime Special January",
        startDateTime: "2021-12-01T03:19:22.096Z",
        endDateTime: "2022-01-31T03:19:22.096Z",
        icon: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        promoTitle:
          "Get 100 THB off for any lunch time order from True Coffee Siam Square",
        promoDescription:
          "For a limited time only, get 100 THB off any Coffee purchase at True Coffee Siam Square during weekday lunch times. Hurry, limited redemption available!",
        tnc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Nulla vitae ac bibendum tristique viverra.<br />Vestibulum leo, porta amet turpis sed molestie aliquam.<br />Massa risus pretium condimentum in commodo bibendum.<br />Enim fusce ac gravida imperdiet urna, elit mauris cursus.<br />In sed molestie id ultricies placerat.<br />Nisl vel egestas mollis aenean tristique bibendum porttitor habitasse.<br />Habitant eget sit quam ultrices vel. Amet amet, arcu sit magna. Euismod ultrices tincidunt a magna dignissim vitae arcu mattis.<br />Libero vestibulum, tortor nunc aliquam dignissim ultricies. Consectetur interdum erat cum lorem tortor urna.<br />Sed orci vitae dignissim magna nunc, imperdiet nulla ut ut.<br />Donec enim blandit fusce non. Sem duis auctor hendrerit at eu lobortis.",
      },
      {
        id: "2",
        thumbnail:
          "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        title: "Weekday Lunchtime Special January",
        merchant: {
          logo: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
          name: "True Coffee",
        },
        company: "True Coffee",
        barCode: "abcdef",
        text: "abc wallet",
        qrCode: "aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2",
        promo: "True Coffee Weekday Lunchtime Special January",
        startDateTime: "2021-12-01T03:19:22.096Z",
        endDateTime: "2022-01-31T03:19:22.096Z",
        icon: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        promoTitle:
          "Get 100 THB off for any lunch time order from True Coffee Siam Square",
        promoDescription:
          "For a limited time only, get 100 THB off any Coffee purchase at True Coffee Siam Square during weekday lunch times. Hurry, limited redemption available!",
        tnc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Nulla vitae ac bibendum tristique viverra.<br />Vestibulum leo, porta amet turpis sed molestie aliquam.<br />Massa risus pretium condimentum in commodo bibendum.<br />Enim fusce ac gravida imperdiet urna, elit mauris cursus.<br />In sed molestie id ultricies placerat.<br />Nisl vel egestas mollis aenean tristique bibendum porttitor habitasse.<br />Habitant eget sit quam ultrices vel. Amet amet, arcu sit magna. Euismod ultrices tincidunt a magna dignissim vitae arcu mattis.<br />Libero vestibulum, tortor nunc aliquam dignissim ultricies. Consectetur interdum erat cum lorem tortor urna.<br />Sed orci vitae dignissim magna nunc, imperdiet nulla ut ut.<br />Donec enim blandit fusce non. Sem duis auctor hendrerit at eu lobortis.",
      },
      {
        id: "3",
        thumbnail:
          "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        title: "Weekday Lunchtime Special January",
        merchant: {
          logo: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
          name: "True Coffee",
        },
        company: "True Coffee",
        barCode: "abcdef",
        text: "abc wallet",
        qrCode: "aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2",
        promo: "True Coffee Weekday Lunchtime Special January",
        startDateTime: "2021-12-01T03:19:22.096Z",
        endDateTime: "2022-01-31T03:19:22.096Z",
        icon: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        promoTitle:
          "Get 100 THB off for any lunch time order from True Coffee Siam Square",
        promoDescription:
          "For a limited time only, get 100 THB off any Coffee purchase at True Coffee Siam Square during weekday lunch times. Hurry, limited redemption available!",
        tnc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Nulla vitae ac bibendum tristique viverra.<br />Vestibulum leo, porta amet turpis sed molestie aliquam.<br />Massa risus pretium condimentum in commodo bibendum.<br />Enim fusce ac gravida imperdiet urna, elit mauris cursus.<br />In sed molestie id ultricies placerat.<br />Nisl vel egestas mollis aenean tristique bibendum porttitor habitasse.<br />Habitant eget sit quam ultrices vel. Amet amet, arcu sit magna. Euismod ultrices tincidunt a magna dignissim vitae arcu mattis.<br />Libero vestibulum, tortor nunc aliquam dignissim ultricies. Consectetur interdum erat cum lorem tortor urna.<br />Sed orci vitae dignissim magna nunc, imperdiet nulla ut ut.<br />Donec enim blandit fusce non. Sem duis auctor hendrerit at eu lobortis.",
      },
      {
        id: "4",
        thumbnail:
          "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        title: "Weekday Lunchtime Special January",
        merchant: {
          logo: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
          name: "True Coffee",
        },
        company: "True Coffee",
        barCode: "abcdef",
        text: "abc wallet",
        qrCode: "aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2",
        promo: "True Coffee Weekday Lunchtime Special January",
        startDateTime: "2021-12-01T03:19:22.096Z",
        endDateTime: "2022-01-31T03:19:22.096Z",
        icon: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        promoTitle:
          "Get 100 THB off for any lunch time order from True Coffee Siam Square",
        promoDescription:
          "For a limited time only, get 100 THB off any Coffee purchase at True Coffee Siam Square during weekday lunch times. Hurry, limited redemption available!",
        tnc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Nulla vitae ac bibendum tristique viverra.<br />Vestibulum leo, porta amet turpis sed molestie aliquam.<br />Massa risus pretium condimentum in commodo bibendum.<br />Enim fusce ac gravida imperdiet urna, elit mauris cursus.<br />In sed molestie id ultricies placerat.<br />Nisl vel egestas mollis aenean tristique bibendum porttitor habitasse.<br />Habitant eget sit quam ultrices vel. Amet amet, arcu sit magna. Euismod ultrices tincidunt a magna dignissim vitae arcu mattis.<br />Libero vestibulum, tortor nunc aliquam dignissim ultricies. Consectetur interdum erat cum lorem tortor urna.<br />Sed orci vitae dignissim magna nunc, imperdiet nulla ut ut.<br />Donec enim blandit fusce non. Sem duis auctor hendrerit at eu lobortis.",
      },
      {
        id: "5",
        thumbnail:
          "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        title: "Weekday Lunchtime Special January",
        merchant: {
          logo: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
          name: "True Coffee",
        },
        company: "True Coffee",
        barCode: "abcdef",
        text: "abc wallet",
        qrCode: "aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2aslkjsdfsdfsdfd2",
        promo: "True Coffee Weekday Lunchtime Special January",
        startDateTime: "2021-12-01T03:19:22.096Z",
        endDateTime: "2022-01-31T03:19:22.096Z",
        icon: "https://1.img-dpreview.com/files/p/E~TS940x788~articles/8792914954/2295831322.jpeg",
        promoTitle:
          "Get 100 THB off for any lunch time order from True Coffee Siam Square",
        promoDescription:
          "For a limited time only, get 100 THB off any Coffee purchase at True Coffee Siam Square during weekday lunch times. Hurry, limited redemption available!",
        tnc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Nulla vitae ac bibendum tristique viverra.<br />Vestibulum leo, porta amet turpis sed molestie aliquam.<br />Massa risus pretium condimentum in commodo bibendum.<br />Enim fusce ac gravida imperdiet urna, elit mauris cursus.<br />In sed molestie id ultricies placerat.<br />Nisl vel egestas mollis aenean tristique bibendum porttitor habitasse.<br />Habitant eget sit quam ultrices vel. Amet amet, arcu sit magna. Euismod ultrices tincidunt a magna dignissim vitae arcu mattis.<br />Libero vestibulum, tortor nunc aliquam dignissim ultricies. Consectetur interdum erat cum lorem tortor urna.<br />Sed orci vitae dignissim magna nunc, imperdiet nulla ut ut.<br />Donec enim blandit fusce non. Sem duis auctor hendrerit at eu lobortis.",
      },
    ],
  },

  profile: {
    items: [
      {
        id: 122,
        tmwID: "tmn.4000000000",
        mobileNumber: "0855555555",
        nationality: "THA",
        thaiID: "3491047332737",
        passportNumber: "",
        abcChainAccount: "0x208a9f2AB9E818D99905A4B04B6072DF8bB16Daa",
        walletIndex: 10121,
        preferredLanguage: "th",
        firstNameEN: "Janyaporn",
        middleNameEN: "",
        lastNameEN: "Preedaangkarakul",
        firstNameTH: "จรรยพร",
        middleNameTH: "",
        lastNameTH: "ปรีดาอัครกุล",
        gender: " ",
        dateOfBirth: "1985-12-10",
        profilePicture: "https://placeimg.com/256/256/people",
        kycLevel: "4",
        kycMinorLevel: "",
        ialLevel: "2.3",
        address: "",
        district: "",
        subDistrict: "",
        province: "",
        postalCode: "",
        createdAt: "2022-03-18T03:19:22.096Z",
        updatedAt: "2022-03-18T03:19:22.096Z",
        deactivatedAt: null,
        deactivationReason: null,
      },
    ],
  },
  rates: {
    from: "True Point",
    to: "ABC Coin",
    rate: 2,
    validationConfig: {
      minimumAbcCoinsToBeSwapped: 1,
    },
  },
  nfts0: {
    size: 5,
    page: 0,
    pageSize: 2,
    cursor: "1",
    data: [
      {
        tokenId: "1",
        nftName: " nft 1",
        collectionName: "collection 1",
        nftUrl:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAclBMVEXb19Xf29ng3NrLxsPZ1dPi393Tz83U0M7l4eCXkIuwqqZwZl5+dW6zrann4+LAureEfHZQQzidlpFmW1JXS0DOycZrYFiSioWrpKB3bWajnJhLPDCMhH4/Lh9hVk1GNyq8trM0IAlbT0UfAAA4JhMoDwDq/gNdAAACNklEQVR4nO3VW4+bMBCGYcbGgCFgTIBwSIBN0///Fws5VKuuqnZvtlR6nwsM4ruY0WATBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+RLSKg0AkWi9RrD4EwkgCicP3YbWFVRR9DO+QOrfZ0RuV1lMsWT/ZD1XHb41Eb9E9nGXZtVeqqlulDllbytcX/HlKFafB5NfQSHoozGUdloQi9+UekK4tsk5e4cwZ2ysj7lgUtX6G5RXep3AW43WqjbuGuk6GdTjXaBmVGx/vzWSP5pkVfTWxb9JINWMU+yDP+rbWQ1t07X7nqezJ6Es5+K44X95y03lJqr4420k/ihb3Tb/KN32u8vlczS4ZbrchWS5hkk5F2/kdz1DmWFydKFe7SUWz7koVNLMy8+k5OFNmh9cMm1HJcEhMd2h8ENbL0ppA3YLwe7rfU0eGraPRKD2dKpOUQ9ev3U5JntXPgKuNd899WA4ieZaorhzKxFTnNSjNmNj+53e8PzI365gOpZtSPebpGHaXYfF5PAdVf5+LeKcW/+gwuqyrTNXidXRJc6+Xm12mTvuit7vdh82w9SGpdUq0reJ1PLnVKl9EbLwF9BpQld5uxeX3Pgar1/9nZRu1ZIt1ptMS23/Ywx88jxORx2XdZmZb5PXmvrxu34W3B1mOv4T/A9Kd//7QkKXf7wnzW/KZmj8VBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/4cffz8ZjYSnJVoAAAAASUVORK5CYII=",
      },
      {
        tokenId: "2",
        nftName: " nft 2",
        collectionName: "collection 2",
        nftUrl:
          "data:image/png;base64,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",
      },
    ],
  },
  nfts1: {
    size: 5,
    page: 1,
    pageSize: 2,
    cursor: "2",
    data: [
      {
        tokenId: "3",
        nftName: " nft 3",
        collectionName: "collection 3",
        nftUrl:
          "data:image/png;base64,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",
      },
      {
        tokenId: "4",
        nftName: " nft 4",
        collectionName: "collection 4",
        nftUrl:
          "https://i0.wp.com/www.printmag.com/wp-content/uploads/2021/02/4cbe8d_f1ed2800a49649848102c68fc5a66e53mv2.gif?fit=476%2C280&ssl=1",
      },
    ],
  },
  nfts2: {
    size: 5,
    page: 2,
    pageSize: 2,
    cursor: "3",
    data: [
      {
        tokenId: "5",
        nftName: " nft 5",
        collectionName: "collection 5",
        nftUrl:
          "https://media.istockphoto.com/photos/extra-wide-evening-panorama-of-business-miami-skyline-picture-id1058108750?b=1&k=20&m=1058108750&s=170667a&w=0&h=YzDzPZd4CXZe1-G_cjL2WIylKsvK2JjgS9MGdQ2uy-Q=",
      },
    ],
  },
  convertPoints: {
    test: "Response test",
  },
  truePointsBalance: {
    loyaltyCustomerId: "L2022041900695386",
    hasTrueId: true,
    mainPointsBalance: 499990,
    firstName: "สุเมธ",
    lastName: "สิริเรืองอำไพ",
    employee: false,
  },
  collections: {
    collections: [
      {
        address: "0xb794f5ea0ba39494ce839613fffba74279579268",
        name: "True CJ1",
        symbol: "TCJ",
        contractURI:
          "https://somecollection.some.where/metadata-collections-1/true-cj/index.json",
      },
      {
        address: "0xb794f5ea0ba39494ce839613fffba74279579200",
        name: "True CJ2",
        symbol: "TCJ",
        contractURI:
          "https://somecollection.some.where/metadata-collections-2/true-cj/index.json",
      },
    ],
  },
  tokens: {
    tokens: [
      {
        tokenID: "1",
        tokenURI:
          "https://somecollection.some.where/metadata-token-1/true-cj/1.json",
        owner: "0xb794f5ea0ba39494ce839613fffba74279579268",
      },
      {
        tokenID: "2",
        tokenURI:
          "https://somecollection.some.where/metadata-token-2/true-cj/2.json",
        owner: "0xb794f5ea0ba39494ce839613fffba74279579268",
      },
      {
        tokenID: "3",
        tokenURI:
          "https://somecollection.some.where/metadata-token-3/true-cj/3.json",
        owner: "0xb794f5ea0ba39494ce839613fffba74279579268",
      },
    ],
  },
  metadataCollection1: {
    name: "OpenSea Creatures1",
    description:
      "OpenSea Creatures are adorable aquatic beings primarily for demonstrating what can be done using the OpenSea platform. Adopt one today to try out all the OpenSea buying, selling, and bidding feature set.",
    image:
      "https://static.remove.bg/remove-bg-web/035676ee65d6ce9f128769532ffdff315f3005c7/assets/start-1abfb4fe2980eabfbbaaa4365a0692539f7cd2725f324f904565a9a744f8e214.jpg",
    external_link: "external-link-url",
    seller_fee_basis_points: 100,
    fee_recipient: "0xA97F337c39cccE66adfeCB2BF99C1DdC54C2D721",
  },
  metadataCollection2: {
    name: "OpenSea Creatures2",
    description:
      "OpenSea Creatures are adorable aquatic beings primarily for demonstrating what can be done using the OpenSea platform. Adopt one today to try out all the OpenSea buying, selling, and bidding feature set.",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg",
    external_link: "external-link-url",
    seller_fee_basis_points: 100,
    fee_recipient: "0xA97F337c39cccE66adfeCB2BF99C1DdC54C2D721",
  },
  metadataToken1: {
    description:
      "Friendly OpenSea Creature that enjoys long swims in the ocean.",
    external_url: "https://openseacreatures.io/3",
    image:
      "https://storage.googleapis.com/opensea-prod.appspot.com/puffs/3.png",
    name: "Dave Starbelly",
    animation_url: null,
    attributes: [
      {
        trait_type: "Base",
        value: "Starfish",
      },
      {
        trait_type: "Eyes",
        value: "Big",
      },
      {
        trait_type: "Mouth",
        value: "Surprised",
      },
    ],
  },
  metadataToken2: {
    description:
      "Friendly OpenSea Creature that enjoys long swims in the ocean.",
    external_url: "https://openseacreatures.io/3",
    image:
      "https://www.litmus.com/wp-content/uploads/2020/01/Linus-Email-GIF.gif",
    name: "Linus Electic",
    animation_url: null,
    attributes: [
      {
        trait_type: "Base",
        value: "Starfish",
      },
      {
        trait_type: "Eyes",
        value: "Big",
      },
      {
        trait_type: "Mouth",
        value: "Surprised",
      },
    ],
  },
  metadataToken3: {
    description:
      "Friendly OpenSea Creature that enjoys long swims in the ocean.",
    external_url: "https://openseacreatures.io/3",
    image:
      "https://lh3.googleusercontent.com/CLfi1hC7InodaqlkL6FS9vst-TC6IZ4moSrMCukUKz5ExgJ1qDjAgUdBmEIjhlrz7UsOK-aAVOKUrhKEnACeqaLCZp4fZ14a5-_E3g",
    name: "Crypto spring NFT mp4",
    animation_url:
      "https://openseauserdata.com/files/05cfc44a759813f43e31d88691b7e5c0.mp4",
    attributes: [
      {
        trait_type: "Base",
        value: "Starfish",
      },
      {
        trait_type: "Eyes",
        value: "Big",
      },
      {
        trait_type: "Mouth",
        value: "Surprised",
      },
    ],
  },
  sendNftTransaction: {
    tokenName: "Crew no.002",
    tokenImage:
      "https://www.litmus.com/wp-content/uploads/2020/01/Linus-Email-GIF.gif",
    dateTime: new Date(),
    transactionId: "0xaabe7dsfdsfgdsfsdfgdsfdseae54d5",
    fromName: "Kwanchanok Phonor",
    fromMobileNumber: "081-222-2222",
    toName: "Mr. Crypto Currency",
    toMobileNumber: "099-999-9999",
  },
  consent: [
    {
      consentName: "sharing-rd",
      application: "wallet",
      title: "To analyze data for research and development",
      content:
        "We will utilize your personal data to do research and development by various data analytics techniques to improve our product quality and user experience. Any personal information that could identify you will be removed or changed before files are shared with other researchers or results are made public. Your identifying information will be replaced with codes. Only the research team will have access to information that identifies you to carry out this research study. Your identifying information will not be shared with others outside this research study.",
      version: "1.0",
      status: null,
    },
    {
      consentName: "direct-marketing",
      application: "wallet",
      title: "To marketing activities (Deal and Promotion)",
      content:
        "We will send you relevant marketing information and carry out market research about our products and services so that you don't miss out on current offers, deals, and promotions. We normally contact our customers by automated or electronic means, including e-mail and phone (e.g., SMS). We sometimes use other means such as websites, mobile apps, posts, or automated calls.",
      version: "1.2",
      status: null,
    },
    {
      consentName: "personalised-marketing",
      application: "wallet",
      title:
        "To profiling activities (Relevant deals & promotions and personalized ads)",
      content:
        "We will analyze your personal preferences, interests, or behaviors so that we can send you customized communications that we think you might like. For example, we will offer products and services, privileges, promotions, and other offers. This consent includes the advertisement of all contents that match your preference and characteristic via different channels. ",
      version: "1.1",
      status: null,
    },
    {
      consentName: "sharing-mkt",
      application: "wallet",
      title: "To analyze data for marketing",
      content:
        "We will improve our marketing plan using data analytics methods resulting from your personal data preferences, interests, or behaviors",
      version: "1.1",
      status: null,
    },
  ],
  partners: {
    total: 1,
    items: [
      {
        id: "krungsri",
        name: {
          en: "krungsri",
          th: "กรุงศรีอยุธยา",
        },
        symbol: "BAY",
        unitName: {
          en: "point",
          th: "คะแนน",
        },
        walletId: 10000,
        createdAt: "2022-04-21T08:51:57.541Z",
        updatedAt: "2022-04-21T08:51:57.541Z",
        rates: [2, 3],
      },
    ],
  },
  linkedAccounts: [
    {
      connected: true,
      displayName: "Krungsri",
      linkedUsername: "myaccount",
      providerAlias: "krungsri",
      providerName: "krungsri",
      social: false,
    },
    {
      connected: true,
      displayName: "Google",
      linkedUsername: "abc@gmail.com",
      providerAlias: "google",
      providerName: "google",
      social: true,
    },
  ],
  convertPartnerDetail: {
    id: "krungsri",
    name: {
      en: "krungsri",
      th: "กรุงศรีอยุธยา",
    },
    symbol: "BAY",
    unitName: {
      en: "point",
      th: "คะแนน",
    },
    walletId: 10000,
    createdAt: "2022-04-21T08:51:57.541Z",
    updatedAt: "2022-04-21T08:51:57.541Z",
    rates: [2, 3],
  },
  convertPartnerBalance: {
    balance: 12345,
  },
  convertPartnerRates: {
    sourceId: "krungsri",
    targetId: "abc",
    effectivePeriod: [1, 7],
    value: 1.2,
    sourceMin: 10,
    sourceMax: 9999999,
  },
  convertPartnerSuccess: {
    id: "1",
    souceId: "krungsri",
    targetId: "abc",
    rate: 1.2,
    sourceAmount: 1000,
    targetAmount: 100.2,
    sourceTxId: "0x123456789",
    targetTxId: "0x987654321",
    status: "active",
    info: {
      details: "abc",
    },
    createdAt: "2022-08-11T09:03:41.248Z",
  },
  f2cRates: {
    provider: "tmn-otp",
    source: "THB",
    target: "ABCP",
    value: "1.2",
    sourceMin: 1,
    sourceMax: 99999,
  },
  f2cTmnOtpAuthCodeSuccess: {
    otpRef: "ABCD",
    paymentRef: "ABC123456789",
    termsUrl: "http://foo.bar",
    retriesLeft: 3,
    validUntil: "2022-10-12T10:53:30.000Z",
  },
  f2cTmnOtpAuthCodeError400: {
    error: "account_invalid",
  },
  f2cTmnOtpAuthCodeError420: {
    error: "cooldown_in_progress",
    info: {
      otpRef: "ABCD",
      termsUrl: "http://foo.bar",
      retriesLeft: 1,
      retriesMax: 5,
      validUntil: "2022-12-04T13:33:03.969Z",
    },
  },
  f2cTmnOtpAuthLinkSuccess: {
    otpRef: "ABCD",
    termsUrl: "http://foo.bar",
    retriesLeft: 3,
    validUntil: "2022-10-12T17:31:00.000Z",
  },
  f2cTmnOtpAuthLinkOtpInvalid: {
    error: "otp_invalid",
    info: {
      otpRef: "ABCD",
      termsUrl: "http://foo.bar",
      retriesLeft: 1,
      retriesMax: 5,
      validUntil: "2022-12-04T13:33:03.969Z",
    },
  },
  f2cTmnOtpAuthLinkMaxRetried: {
    error: "max_retries_reached",
    info: {
      otpRef: "ABCD",
      termsUrl: "http://foo.bar",
      retriesLeft: 0,
      retriesMax: 5,
      validUntil: "2022-12-04T13:33:03.969Z",
    },
  },
  f2cTransaction: {
    id: 12334434,
    status: "success",
    userId: "9902010292",
    profileId: 1232,
    source: "THB",
    sourceTxId: "tmn1002020202",
    sourceAmount: "100",
    target: "ABC",
    targetTxId: "0x32ab1232bs....",
    targetAmount: "1000",
    metadata: {
      custom: "data from provider if any",
    },
    created_at: "2022-12-04T13:33:03.000Z",
    updated_at: "2022-12-04T13:33:55.000Z",
  },
  f2cTransactionBalanceInsufficient: {
    error: "funds_insufficient",
  },
  f2cTransactionError: {
    error: null,
  },
};

// const error = {
//   code: 50003,
//   title: "Business Profile Error",
//   body: "",
//   description: "",
// };
const customerApiMock = mock => {
  mock
    .onGet("/getLatestTnc?language=en&service=abc-wallet-tnc")
    .reply(config => {
      const response = DB.terms;
      return [200, response];
    });

  mock.onPost("protocol/openid-connect/token").reply(config => {
    //console.log("protocol/openid-connect/token", config);

    const response = DB.auth;
    return [200, response];
  });

  // mock.onPost("protocol/openid-connect/token").reply((config) => {
  //   console.log("protocol/openid-connect/token", config);

  //   return [403, { message: "inactive account" }];
  // });

  mock.onPost("abc-terms").reply(config => {
    //console.log("abc-terms", config);
    const response = DB.acceptTerms;
    return [200, response];
  });

  mock.onGet("/test").reply(config => {
    //console.log("/test", config);

    const response = DB.register;
    return [200, response];
  });

  mock.onGet("/deals?page=1&limit=10").reply(config => {
    const response = DB.deals;
    return [200, response];
  });

  mock.onGet("/deals?page=2&limit=10").reply(config => {
    const response = DB.deals2;
    return [200, response];
  });

  mock.onGet("/deals?page=3&limit=10").reply(config => {
    const response = DB.dealsEmtpy;
    return [200, response];
  });

  mock.onGet("/deals?page=1&limit=10&merchant=1").reply(config => {
    const response = DB.deals;
    return [200, response];
  });

  mock.onGet("/deals?page=2&limit=10&merchant=1").reply(config => {
    const response = DB.dealsEmtpy;
    return [200, response];
  });

  mock.onGet("/merchants?page=1&limit=10").reply(config => {
    const response = DB.merchants;
    return [200, response];
  });
  mock.onGet("/merchants?page=2&limit=10").reply(config => {
    const response = DB.merchants2;
    return [200, response];
  });

  mock.onGet("/merchants?page=1&limit=20").reply(config => {
    const response = DB.merchants3;
    return [200, response];
  });

  mock.onGet(new RegExp(`balances/*`)).reply(config => {
    const response = DB.coins;
    return [200, response];
  });

  mock.onGet(new RegExp(`transfers/mine/*`)).reply(config => {
    const response = DB.transactionHistory;
    return [200, response];
  });

  mock.onGet(new RegExp(`vouchers/mine/*`)).reply(config => {
    const params = parseQueryString(config.url);
    const response = DB[`vouchers${params.page}`];
    return [200, response];
  });

  mock.onGet(new RegExp(`profile/*`)).reply(config => {
    const response = DB.profile;
    return [200, response];
  });

  mock.onGet(new RegExp(`/abc-swap-service`)).reply(config => {
    const response = DB.rates;
    return [200, response];
  });

  mock.onGet(new RegExp(`nfts/*`)).reply(config => {
    console.log(config.url.split("/")[2]);
    if (config.url.split("/")[2].indexOf("error") != -1) {
      return [403];
    }
    const params = parseQueryString(config.url);
    const response = DB[`nfts${params.cursor === "" ? 0 : params.cursor}`];
    return [200, response];
  });

  mock.onPost("convertPoints").reply(config => {
    const response = DB.convertPoints;
    return [200, response];
  });

  mock.onGet(new RegExp("trueid/points-balance")).reply(config => {
    const response = DB.truePointsBalance;
    return [200, response];
  });

  mock.onGet("collections").reply(() => {
    const response = DB.collections;
    return [200, response];
  });

  mock
    .onGet("tokens?collection=0xb794f5ea0ba39494ce839613fffba74279579268")
    .reply(() => {
      const response = DB.tokens;
      return [200, response];
    });
  mock
    .onGet("tokens?collection=0xb794f5ea0ba39494ce839613fffba74279579200")
    .reply(() => {
      const response = DB.tokens;
      return [200, response];
    });

  mock.onGet(/metadata-collections-1/).reply(() => {
    const response = DB.metadataCollection1;
    return [200, response];
  });

  mock.onGet(/metadata-collections-2/).reply(() => {
    const response = DB.metadataCollection2;
    return [200, response];
  });

  mock.onGet(/metadata-token-1/).reply(() => {
    const response = DB.metadataToken1;
    return [200, response];
  });

  mock.onGet(/metadata-token-2/).reply(() => {
    const response = DB.metadataToken2;
    return [200, response];
  });

  mock.onGet(/metadata-token-3/).reply(() => {
    const response = DB.metadataToken3;
    return [200, response];
  });

  mock.onPost(/collections\/.*\/transfers/).reply(() => {
    const response = DB.sendNftTransaction;
    return [200, response];
  });

  mock.onPost("required-consent").reply(() => {
    const response = DB.consent;
    return [200, response];
  });

  mock.onGet(/point-exchange\/v2\/linked-accounts/).reply(() => {
    const response = DB.linkedAccounts;
    return [200, response];
  });
  mock.onGet(/point-exchange\/v2\/partners\/.*\/balance\/caller/).reply(() => {
    const response = DB.convertPartnerBalance;
    return [200, response];
  });
  mock.onGet(/point-exchange\/v2\/partners\/.*/).reply(() => {
    const response = DB.convertPartnerDetail;
    return [200, response];
  });
  mock.onGet(/point-exchange\/v2\/partners/).reply(() => {
    const response = DB.partners;
    return [200, response];
  });
  mock.onGet(/point-exchange\/v2\/rates/).reply(() => {
    const response = DB.convertPartnerRates;
    return [200, response];
  });
  mock.onPost(/point-exchange\/v2\/swaps/).reply(() => {
    const response = DB.convertPartnerSuccess;
    return [200, response];
  });

  // F2C
  mock.onGet(/f2c\/rates\/.*/).reply(() => {
    const response = DB.f2cRates;
    return [200, response];
  });
  mock.onPost(/f2c\/providers\/tmn-otp\/auth\/code/).reply(() => {
    const response = DB.f2cTmnOtpAuthCodeSuccess;
    return [200, response];
  });
  mock.onPost(/f2c\/400\/providers\/tmn-otp\/auth\/code/).reply(() => {
    const response = DB.f2cTmnOtpAuthCodeError400;
    return [400, response];
  });
  mock.onPost(/f2c\/420\/providers\/tmn-otp\/auth\/code/).reply(() => {
    const response = DB.f2cTmnOtpAuthCodeError420;
    return [420, response];
  });
  mock.onPost(/f2c\/providers\/tmn-otp\/auth\/link/).reply(() => {
    const response = DB.f2cTmnOtpAuthLinkSuccess;
    return [200, response];
  });
  mock.onPost(/f2c\/400\/providers\/tmn-otp\/auth\/link/).reply(() => {
    const response = DB.f2cTmnOtpAuthLinkOtpInvalid;
    return [400, response];
  });
  mock.onPost(/f2c\/420\/providers\/tmn-otp\/auth\/link/).reply(() => {
    const response = DB.f2cTmnOtpAuthLinkMaxRetried;
    return [420, response];
  });
  mock.onPost(/f2c\/transactions/).reply(() => {
    const response = DB.f2cTransaction;
    return [200, response];
  });
  mock.onPost(/f2c\/420\/transactions/).reply(() => {
    const response = DB.f2cTransactionBalanceInsufficient;
    return [420, response];
  });
  mock.onPost(/f2c\/500\/transactions/).reply(() => {
    const response = DB.f2cTransactionError;
    return [500, response];
  });
};
export default customerApiMock;
// Mock.onPost("/abc-cpoint-composite/v1/api/cpointrate").reply((config) => {
//   let {
//     businessProfileId,
//     cpointExchangeRate,
//     lastApprovalDate,
//     approvedBy,
//     proposedExchangeRate,
//     proposalStatus,
//     proposalDate,
//     proposedBy,
//   } = JSON.parse(config.data);

//   const indx = buListDB.buList.findIndex(
//     (x) => x.businessProfileId === businessProfileId
//   );
//   buListDB.buList[indx].cpointExchangeRate = proposedExchangeRate;
//   buListDB.buList[indx].lastApprovalDate = lastApprovalDate;
//   buListDB.buList[indx].approvedBy = approvedBy;
//   buListDB.buList[indx].proposedExchangeRate = proposedExchangeRate;
//   buListDB.buList[indx].proposalStatus = proposalStatus;
//   buListDB.buList[indx].proposalDate = proposalDate;
//   buListDB.buList[indx].proposedBy = proposedBy;

//   const response = buListDB.buList;

//   return [200, response];
// });

const parseQueryString = url => {
  const queryString = url.replace(/.*\?/, "");

  if (queryString === url || !queryString) {
    return null;
  }

  const urlParams = new URLSearchParams(queryString);
  const result = {};

  urlParams.forEach((val, key) => {
    if (result.hasOwnProperty(key)) {
      result[key] = [result[key], val];
    } else {
      result[key] = val;
    }
  });

  return result;
};
